import { useBlockProps } from "@wordpress/block-editor";
import { useEffect, useState } from "@wordpress/element";

import "./index.css";

const Edit = (props) => {
    const [productVariations, setProductVariations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // get Product Data
    const postId = wp.data.select("core/editor").getCurrentPostId();
    const postType = wp.data.select("core/editor").getCurrentPostType();

    //get attributes
    const { attributes, setAttributes } = props;

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(
                    EASYCOMMERCE.rest_base + "/products/" + postId
                );
                const data = await response.json();
                setIsLoading(false);

                setProductVariations(data.data.variations);
            } catch (error) {;
            }
        };
        fetchProducts();
    }, []);

    const blockProps = useBlockProps();

    // Function to get all common attributes
    const getCommonAttributes = (productVariations) => {
        const commonAttributes = {};

        productVariations.forEach((variation) => {
            const { attributes } = variation;
            for (const key in attributes) {
                if (!commonAttributes[key]) {
                    commonAttributes[key] = new Set();
                }
                commonAttributes[key].add(attributes[key]);
            }
        });

        const result = {};
        for (const key in commonAttributes) {
            result[key] = Array.from(commonAttributes[key]);
        }

        return result;
    };

    // Get common attributes
    const commonAttributes = getCommonAttributes(productVariations);

    return postType === "product" ? (
        <>
            <div {...blockProps}>
                {!isLoading &&
                    Object.keys(commonAttributes).map((items, index) => (
                        <div key={index}>
                            <lable className="block text-ec-body font-inter font-normal text-base leading-[26px] mb-4">
                                {items}
                            </lable>
                            <div className="flex items-center gap-3 mb-6 flex-wrap">
                                {commonAttributes[items].map((item, index) => (
                                    <span
                                        keys={index}
                                        className="inline-block py-3 px-5 rounded-md text-ec-body 
                                        font-inter text-base leading-[26px] font-semibold cursor-point bg-ec-accent 
                                        hover:bg-ec-primary hover:text-white transition-all"
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
            </div>
        </>
    ) : (
        <div {...blockProps}>
            <p>Post type is not product.</p>
        </div>
    );
};

export default Edit;

{
    /* {Object.keys(commonAttributes).length > 0 &&
        Object.keys(commonAttributes).map((items, index) => (
            <>
                {commonAttributes[items].length > 0 && (
                    <div key={index}>
                        <lable className="block text-ec-body font-inter font-normal text-base leading-[26px] mb-4">
                            {items}:
                        </lable>
                        <div className="flex items-center gap-3 mb-6 flex-wrap">
                            {commonAttributes[items].map(
                                (item, index) => (
                                    <span
                                        keys={index}
                                        className="inline-block py-3 px-5 bg-[#1203500D] rounded-md text-ec-body 
                                        font-inter text-base leading-[26px] font-semibold cursor-pointer 
                                        hover:bg-ec-primary hover:text-white transition-all"
                                    >
                                        {item}
                                    </span>
                                )
                            )}
                        </div>
                    </div>
                )}
            </>
        ))} */
}
